var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 104,
    viewBox: "0 0 133 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.49 47.5759L115.276 62.2071L130.052 64.0786L116.998 71.2497L119.784 85.8809L108.93 75.6816L95.876 82.8527L102.222 69.3782L91.3678 59.179L106.144 61.0504L112.49 47.5759Z",
    fill: "#E6889F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.031 22.2654L104.104 32.3443L114.639 32.5371L106.002 38.5735L109.074 48.6524L100.665 42.3041L92.0284 48.3405L95.4673 38.3807L87.0576 32.0324L97.5926 32.2252L101.031 22.2654Z",
    fill: "#445597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5166 12.316L56.8988 36.8562L85.6093 27.9081L67.6416 52.0229L85.0238 76.5631L56.5369 66.9266L38.5692 91.0414L38.9311 60.971L10.4442 51.3346L39.1547 42.3864L39.5166 12.316Z",
    fill: "#FEE8B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars3);
export default __webpack_public_path__ + "static/media/stars-3.f10068eb9171852957ba3e011641e19b.svg";
export { ForwardRef as ReactComponent };